document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.main-content > div')
  if (el) {
    el.classList.add('l40-ultra-a')
  }

  document
    .querySelectorAll('.l40-ultra-a-img-text-1 .video-box')
    .forEach(function (box) {
      var videos = box.querySelectorAll('video')
      if (!videos.length) return
      function update() {
        var anyPlaying = Array.prototype.some.call(videos, function (v) {
          return !v.paused && !v.ended
        })
        box.classList.toggle('is-paused', !anyPlaying)
      }
      videos.forEach(function (v) {
        v.addEventListener('play', update)
        v.addEventListener('playing', update)
        v.addEventListener('pause', update)
        v.addEventListener('ended', update)
      })
      update()
    })
})
